module.exports = __webpack_public_path__ + "img/defense_community.09ed744d.jpg";